import { Box, Button } from '@mui/material';
import { useLocation } from 'react-router-dom';
import Header from '../../../../shared/components/Header/Header';
import useBlacklistManagement from '../../hooks/useBlacklistManagement';
import { Blacklist } from '../../interfaces/BlacklistType';
import styles from './BlacklistHeader.module.scss';

const BlacklistHeader = () => {
  const { setOpen } = useBlacklistManagement();
  const { pathname } = useLocation();
  const isLoyalty = pathname.includes(Blacklist.LOYALTY);

  return (
    <Box id={styles.blacklistHeader}>
      <Header
        title='Blacklist'
        description='Restrict access and privileges for flagged customers'
      />
      {isLoyalty && (
        <Button
          onClick={() => {
            console.log('button clicked');
            setOpen(true);
          }}
        >
          Create New Customer Group
        </Button>
      )}
    </Box>
  );
};

export default BlacklistHeader;
